import _ from 'lodash'
import * as ds from '~/scriptData/ds/dsCommon.js'

/**
 * packageName    : ds
 * fileName       : dsMixin.js
 * author         :
 * date           : 2023-08-21
 * description    : 코너 ID로 구좌 리스트 및 소재 리스트 조회
 * =============================================================
 * DATE             AUTHOR          NOTE
 * -------------------------------------------------------------
 * 2023-08-21       Leehj         최초생성
 */
const exbtAsyncData = {
  async asyncData ({ $api, params }) {
    // 코너 id
    const exhCnrId = params.id

    // getAccntList(코너 id, $api)의 return: 구좌 List
    const accountList = await ds.getAccntList(exhCnrId, $api)

    // getMtrlsList(구좌 list, $api)의 return: 소재 List
    const mtrlsList = await ds.getMtrlsList(accountList, $api)

    /**
     * 이번주 기획전 배너정보 조회
     */
    const bannerList = mtrlsList?.flatMap((e) => {
      if (!_.isEmpty(e)) {
        return e
          .filter(item => item?.banrTyCd !== null && item?.banrTyCd !== undefined)
          .flatMap((item) => {
            return item.details
              .filter(obj => obj.banrTypCd !== null)
          })
      } else { return null }
    })

    return {
      accountList,
      mtrlsList,
      bannerList,
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    searchExbtDtl () {
      return this.exbtMtrlsList
    }
  }
}

export {
  exbtAsyncData
}
